import { render } from "./index.vue?vue&type=template&id=48251274&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=48251274&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48251274"]])

export default __exports__